export const getters = {
  banners: state => state.banners,
  currentBanner: state => state.currentBanner
}